interface QueryParamsInterface {
  limit?: any;
  page?: any;
  search?: string;
  ordering?: string;
  year?: string | number;
  month?: string | number;
  type?: string | number;
  accountNo?: string;
  loan?: string;
  pin_no?: string | number;
  group?: string | number;
  offset?: string | number;
}
const queryParams = ({
  limit,
  page,
  search,
  year,
  month,
  type,
  pin_no,
  accountNo,
  loan,
  group,
  offset,
}: QueryParamsInterface): string => {
  let params = '?';
  if (limit && page) params += `page=${page}&limit=${limit}`;
  if (limit) params += `&limit=${limit}`;
  if (offset) params += `&offset=${offset}`;
  if (group) params += `&group=${group}`;
  if (search) params += `&search=${search}`;
  if (year) params += `&year=${year}`;
  if (month) params += `&month=${month}`;
  if (type) params += `&type=${type}`;
  if (pin_no) params += `&pin_no=${pin_no}`;
  if (accountNo) params += `&account-no=${accountNo}`;
  if (loan) params += `&loan-no=${loan}`;
  return params;
};

export default queryParams;
